var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("累计存款档位设置")]),
      _c(
        "div",
        { staticClass: "red-tiers-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _setup.addTier },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "status-tip", staticStyle: { "margin-bottom": "8px" } },
        [_vm._v("保存时将按存款门槛从低到高排序")]
      ),
      _c(
        "el-table",
        {
          staticClass: "tier-table",
          attrs: {
            data: _vm.localForm.payinRebateTiers,
            border: "",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "存款达标金额", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        min: 0,
                        precision: 2,
                        controls: false,
                        size: "mini",
                        placeholder: "请输入存款金额",
                      },
                      model: {
                        value: scope.row.threshold_yuan,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "threshold_yuan", $$v)
                        },
                        expression: "scope.row.threshold_yuan",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励金额", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        min: 0,
                        precision: 2,
                        controls: false,
                        size: "mini",
                        placeholder: "请输入奖励金额",
                      },
                      model: {
                        value: scope.row.gold_yuan,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "gold_yuan", $$v)
                        },
                        expression: "scope.row.gold_yuan",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.settled_count))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "danger-button",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _setup.removeTier(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "16px" } },
        [
          _c(
            "el-form-item",
            { attrs: { "label-width": "140px", label: "活动循环模式" } },
            [
              _c("el-input-number", {
                attrs: { min: 1, precision: 0, controls: false, size: "mini" },
                model: {
                  value: _vm.localForm.payinRebateRule.cycle_days,
                  callback: function ($$v) {
                    _vm.$set(_vm.localForm.payinRebateRule, "cycle_days", $$v)
                  },
                  expression: "localForm.payinRebateRule.cycle_days",
                },
              }),
              _c("span", { staticClass: "rule-suffix" }, [_vm._v("天")]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { "label-width": "140px", label: "活动计算模式" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.localForm.payinRebateRule.calculate_type,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localForm.payinRebateRule,
                        "calculate_type",
                        $$v
                      )
                    },
                    expression: "localForm.payinRebateRule.calculate_type",
                  },
                },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: _setup.CALCULATE_TYPE_ACCUMULATE } },
                    [_vm._v("累加模式(总额累计)")]
                  ),
                  _c(
                    "el-radio",
                    { attrs: { label: _setup.CALCULATE_TYPE_INDEPENDENT } },
                    [_vm._v("达标模式(差额升级)")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "status-tip",
                  staticStyle: { "margin-top": "8px" },
                },
                [
                  _c("span", [
                    _vm._v(
                      "累加模式(总额累计)指每一档金额为升级所需的存款总额。示例：升级第二档需存满200，若已完成第一档(100),需再存 "
                    ),
                    _c("b", [_vm._v("200")]),
                    _vm._v("（即总存款达"),
                    _c("b", [_vm._v("300")]),
                    _vm._v("）方可解锁"),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      "达标模式(差额升级)指每一档金额为升级所需的额外存款额。示例：升级第二档需存满200，若已完成第一档(100),需再存 "
                    ),
                    _c("b", [_vm._v("100")]),
                    _vm._v("（即总存款达"),
                    _c("b", [_vm._v("200")]),
                    _vm._v("）即可解锁"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { "label-width": "140px", label: "奖励稽核倍数" } },
            [
              _c("el-input-number", {
                staticClass: "rule-input-num",
                attrs: { min: 0, precision: 2, controls: false },
                model: {
                  value: _vm.localForm.payinRebateRule.multiple,
                  callback: function ($$v) {
                    _vm.$set(_vm.localForm.payinRebateRule, "multiple", $$v)
                  },
                  expression: "localForm.payinRebateRule.multiple",
                },
              }),
              _c("span", { staticClass: "rule-suffix" }, [_vm._v("倍")]),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "form-item-vips",
              attrs: {
                label: "活动对象",
                prop: "vips",
                "label-width": "140px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "vips-wrap", staticStyle: { width: "80%" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        indeterminate: _setup.vipIndeterminate,
                        value: _setup.isAllVipChecked,
                      },
                      on: { change: _setup.onVipCheckAllChange },
                    },
                    [_vm._v(" 全选 ")]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "vips-group",
                      on: { change: _setup.syncVipCheckAllState },
                      model: {
                        value: _vm.localForm.vips,
                        callback: function ($$v) {
                          _vm.$set(_vm.localForm, "vips", $$v)
                        },
                        expression: "localForm.vips",
                      },
                    },
                    _vm._l(_vm.vipOptions, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }